import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import AlertBanner from "./components/AlertBanner";
import TrackSection from "./components/TrackSection";
import InfoCards from "./components/InfoCards";
import MainContent from "./components/MainContent";
import FeaturedSections from "./components/FeaturedSections";
import IndustrySectors from "./components/IndustrySectors";
import InsightsSection from "./components/InsightsSection";
import NewsSection from "./components/NewsSection";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <AlertBanner />
      <TrackSection />
      <InfoCards />
      <MainContent />
      <FeaturedSections />
      <IndustrySectors />
      <InsightsSection />
      <NewsSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
